export enum PATIENT_STATUS {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}
